import { format, isValid } from "date-fns"

/**
 * Format date for display
 *
 * @param date
 * @param dateStyle - default dateStyle + allow null to use default
 * @param timeStyle - default timeStyle + allow null to use default
 * @returns Date string or empty string if date is invalid
 */
export function formatDateForDisplay(
  date: string | number | Date | null | undefined,
  dateStyle: "short" | "medium" | "long" | "full" | null = "short",
  timeStyle: "short" | "medium" | "long" | "full" | null = "short"
): string {
  if (!date) return ""
  const d = new Date(date)
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return isValid(d)
    ? d.toLocaleString("en-GB", {
        timeZone: userTimezone,
        ...(dateStyle && { dateStyle }),
        ...(timeStyle && { timeStyle })
      })
    : ""
}

export function formatDateForDatabase(
  date: string | number | Date | null | undefined
): Date {
  if (!date) return new Date()
  return new Date(date)
}

export function formatDateForDateTimeLocalInput(
  date: string | number | Date | null | undefined
): string {
  if (!date) return ""
  const d = new Date(date)
  return isValid(d) ? format(d, "yyyy-MM-dd'T'HH:mm") : ""
}
